import React from 'react';
import './main.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Post from './pages/Post';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/post/:postId' element={<Post />} />
      </Routes>
    </Router>
  );
}

export default App;
